import axios from "axios";

const get = (path, config) => axios.get(`/api${path}`, config).then(({ data }) => data);
const post = (path, config) => axios.post(`/api${path}`, config);
const patch = (path, config) => axios.patch(`/api${path}`, config);
const put = (path, config) => axios.put(`/api${path}`, config);
const remove = (path, config) => axios.delete(`/api${path}`, config);

const download = (path, fileName) => {
    let anchor = document.createElement("a");
    document.body.appendChild(anchor);

    axios({
        url: path,
        method: 'GET',
        responseType: 'blob',
    })
        .then(response => {
            let objectUrl = window.URL.createObjectURL(response.data);

            anchor.href = objectUrl;
            anchor.download = fileName ? fileName : response.headers["content-disposition"].split('filename=')[1].split(';')[0].replaceAll('"','') || 'THOMerch';
            document.body.appendChild(anchor);
            anchor.click();

            document.body.removeChild(anchor);
            window.URL.revokeObjectURL(objectUrl);
        });
};

export { get, post, patch, put, remove, download };
